import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import { AlgoAPIModel } from "../../Models/API/AlgoAPIModel";
import { useState } from "react";
import { DialogValuesInterface } from "../../Components/Emergency/DialogValues";

interface StatefulDialogProps extends DialogProps {
  algos?: AlgoAPIModel[];
  setOpen(open: boolean): void;
  displayValues: DialogValuesInterface;
  apiRequest: () => Promise<void>;
}

const StatefulDialog = (props: StatefulDialogProps) => {
  const { setOpen, displayValues, apiRequest, ...dialogProps } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (agreed: boolean) => () => {
    if (agreed) {
      setIsLoading(true);
      //window.setTimeout(() => {setIsStopped(stop ? true : false); setIsLoading(false); setOpen(false);}, 2000); //<-- use to test button
      // Failures are reported by the caller (the mutations' onError); swallow
      // them here so a rejected request still closes the dialog instead of
      // leaving it spinning.
      apiRequest()
        .catch(() => undefined)
        .then(() => {
          setOpen(false);
          // This is done with a timeout, to ensure the dialog is closed, before it is set back to the initial view
          setTimeout(function () {
            setIsLoading(false);
          }, 100);
        });
    } else {
      setOpen(false);
    }
  };

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>{displayValues.title}</DialogTitle>
      <DialogContent>
        {!isLoading ? (
          <span>{displayValues.body}</span>
        ) : (
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignContent: "center",
            }}
          >
            {displayValues.loading}
            <CircularProgress style={{ alignSelf: "center" }} />
          </span>
        )}
      </DialogContent>
      {isLoading ? (
        <></>
      ) : (
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleClose(true)}
            color="success"
            disabled={isLoading}
            autoFocus
          >
            {displayValues.confirm}
          </Button>
          <Button
            variant="contained"
            onClick={handleClose(false)}
            color="secondary"
            disabled={isLoading}
          >
            {displayValues.cancel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export { StatefulDialog };
